import { styled, css } from 'styled-components';
import { Utils, theme } from 'team-hero-ui';

import type { TTableStyleValue } from 'components/Table/Table.types';

const { pxToRem, flexFn } = Utils;

interface IStyledTableBody {
  $styleType?: TTableStyleValue;
}

interface IStyledTableCellProps extends IStyledTableBody {
  $isFirst: boolean;
  $disabled?: boolean;
  $autoHeight?: boolean;
  $firstChildBorderRadius?: boolean;
}

interface ITableMinStyledProps {
  $isMin: boolean;
  $styleType?: TTableStyleValue;
}

const getBackgroundColor = (
  isFirst = false,
  disabled = false,
  $styleType?: TTableStyleValue
): string => {
  if (isFirst) {
    return 'inherit';
  }

  if (disabled) {
    if ($styleType === 'modal') {
      return theme.colors.greyShades.grey15;
    }

    if ($styleType === 'modalBright') {
      return theme.colors.primary.white;
    }

    return theme.colors.greyShades.grey6;
  }

  return theme.colors.primary.white;
};

interface ITruncatedCellProps {
  $disabled?: boolean;
}

export const TruncatedCellStyled = styled.div<ITruncatedCellProps>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${pxToRem(14)};
  margin-right: ${pxToRem(20)};
  color: ${({ $disabled }) =>
    $disabled ? theme.colors.primary.grey : 'inherit'};
`;

export const StyledTableCell = styled.div<IStyledTableCellProps>`
  ${flexFn('flex-start')};
  min-height: ${pxToRem(49)};
  font-size: ${pxToRem(14)};
  color: ${({ $disabled }) =>
    $disabled ? theme.colors.greyShades.grey2 : theme.colors.primary.grey};
  background-color: ${({ $isFirst, $disabled, $styleType }) =>
    getBackgroundColor($isFirst, $disabled, $styleType)};
  ${({ $firstChildBorderRadius }) =>
    $firstChildBorderRadius &&
    css`
      border-top-left-radius: ${pxToRem(5)};
      border-bottom-left-radius: ${pxToRem(5)};
    `};

  &:last-child {
    border-radius: ${pxToRem([0, 5, 5, 0])};
  }
`;

export const FocusDiv = styled.div`
  cursor: pointer;
`;

export const StyledTableBodyRow = styled.div<ITableMinStyledProps>`
  display: block;
  position: relative;
  font-size: ${pxToRem(14)};
  border-radius: ${pxToRem(5)};
  margin-bottom: ${pxToRem(4)};
  transition: all 0.05s ease-in;

  .more-icon-row {
    svg .cls-2 {
      fill: ${theme.colors.primary.white};
      pointer-events: none;
    }
  }

  &:hover {
    .more-icon-row {
      svg .cls-2 {
        fill: ${theme.colors.greyShades.grey4};
      }
    }
    box-shadow: ${({ $isMin }) =>
      $isMin ? 'none' : `${pxToRem([0, 0, 17, -10])} rgb(0 0 0 / 90%)`};
  }
`;

interface IStyledTableBodyInnerRow {
  $gridColsWidth: string;
}

export const StyledTableBodyInnerRow = styled.div<IStyledTableBodyInnerRow>`
  display: grid;
  position: relative;
  grid-template-columns: ${({ $gridColsWidth }) => $gridColsWidth};
`;
